
import { Subject } from 'rxjs';

const subject = new Subject();

export const taskUpdateService = {
    sendTask: task => subject.next(task),
    clearTask: () => subject.next(),
    getTask: () => subject.asObservable()
};